import { PropertyFilterOption } from "@amzn/awsui-collection-hooks/cjs/interfaces";
import { FilterOptionBucketCount } from "../searchSideBar/filterWithAggregatedDataConnector";

/**
 * Fold the match count into each option's label ("Alexa" -> "Alexa (12)",
 * missing/zero bucket -> "(0)") and order like the legacy sidebar:
 * nonzero-count options first, then zero, alphabetical by label within
 * each tier. Pure, so it's unit-testable without a DOM.
 */
export const withCountLabels = (
  options: PropertyFilterOption[],
  counts: FilterOptionBucketCount
): PropertyFilterOption[] => {
  const nonZero: PropertyFilterOption[] = [];
  const zero: PropertyFilterOption[] = [];

  options.forEach((option) => {
    const bucket = option.value ? counts[option.value] : undefined;
    const count = bucket && bucket.count > 0 ? bucket.count : 0;
    const labeled = { ...option, label: `${option.label ?? ""} (${count})` };
    (count > 0 ? nonZero : zero).push(labeled);
  });

  const byLabel = (a: PropertyFilterOption, b: PropertyFilterOption) =>
    (a.label ?? "").localeCompare(b.label ?? "");

  return [...nonZero.sort(byLabel), ...zero.sort(byLabel)];
};
